import styled from 'styled-components';
import chroma from 'chroma-js';

export const width = '35px';
const color = chroma('#0875e3');

export default styled.button.attrs({ type: 'submit' })`
  font-size: 0.8rem;
  position: absolute;
  right: 0;
  top: 0;
  text-align: center;
  width: ${width};
  cursor: pointer;
  line-height: calc(60px / 2);
  color: ${color};
  padding: 0;
  margin: 0%;
  background: transparent;
  border: none;

  &:hover {
    color: ${color.darken()};
  }
`;
